import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockText from "../../Block/BlockText";
import BlockImage from "../../Block/BlockImage";
import Block from "../../Block/Block";

function ImmerseDecorVR() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>ImmerseDecorVR</BlockTitle>
        </BlockContent>
        <BlockContent>
          <BlockText>ImmerseDecorVR is a Virtual Reality application that showcases my work in 3D reconstruction and color transfer. The app allows users to explore detailed reconstructions of both small objects and large-scale rooms, with the ability to change colors, providing an immersive and engaging experience.</BlockText>
        </BlockContent>
      </Block>

      <Block gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockText>ImmerseDecorVR is an application that allows users to explore the university (EAH Jena) digitally through a Virtual Reality headset. Interior spaces were reconstructed using laser scanners and prepared for display. This demonstration offered more than just a simple visualization of a 3D model of the university. With an intuitive user interface, visitors could adjust the lighting and textures of the virtual scene. They could view rooms in the post-impressionist style of Van Gogh or the abstract style of Wassily Kandinsky. The results shown were generated by artificial intelligence algorithms, providing insight into the application of AI in the artistic field. This immersive experience allows users to view the university from a completely new perspective—in the context of artificial intelligence and alongside significant works of art history.
          This demonstration was presented in 2022 for the <i>Long Night of the Sciences</i> as an exhibit by the Department of Electrical Engineering and Information Technology. The video provides a glimpse into this application
          </BlockText>
        </BlockContent>
        <BlockContent>
              <BlockImage src={process.env.PUBLIC_URL + '/images/projects/example_imersedecorvr.webp'} title="AI Meets Art: The Ernst Abbe University as a Work of Art in Kandinsky’s Style"/>
        </BlockContent>
      </Block>

      <Block gridTemplateColumns="600px 600px">
        <BlockContent>
              <BlockImage src={process.env.PUBLIC_URL + '/images/projects/eah_digital.webp'} title="Between Reality and Virtuality: The Department of Electrical Engineering and Information Technology Goes Digital"/>
        </BlockContent>
        <BlockContent>
        <video width="100%"controls >
              <source src="https://potechius.com/Videos/LNdW_Demo.mp4" type="video/mp4"/>
        </video>
        </BlockContent>
      </Block>

      <Footer/>
    </div>
  );
}

export default ImmerseDecorVR;